import { Button, Select } from 'antd'
import React from 'react'
import { dataTimeLogOut } from '../../../../services/data'
import useInfoUser from '../../../../hook/useInfoUser'
import useDebounce from '../../../../hook/useDebounce'
import useToast from '../../../../hook/useToast'
import useLoading from '../../../../hook/useLoading'
import { addWorkSession } from '../../../../api/workSessionSetting/workSessionSettingApi'
import { MailOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

const Share = () => {
    const navigate = useNavigate()
    const { getInfoUser, setTimeSessionTimeout } = useInfoUser()
    const { sessionTimeout } = getInfoUser()
    const pushToast = useToast();
    const pushLoading = useLoading()

    const onChangeSessionTimeout = useDebounce(async (value: number) => {
        pushLoading(true)
        const result = await addWorkSession(value)
        if (result?.status) {
            setTimeSessionTimeout(value)
        } else {
            pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }, 1000)
    return (
        <div className='d-flex flex-column gap-4'>
            <div className="custom-page-css flex items-center justify-between">
                <span className='custom-page-css text-base font-medium'>Thời gian phiên làm việc</span>
                <div className="custom-page-css flex items-center gap-2">
                    <span className='custom-page-css text-base font-regular'>Đăng xuất hệ thống sau</span>
                    <div className="custom-page-css flex flex-1 border rounded">

                        <Select
                            className='custom-page-css flex  w-full w-100-px '
                            placeholder=""
                            options={dataTimeLogOut}
                            value={sessionTimeout}
                            onChange={onChangeSessionTimeout}
                        />
                    </div>
                    <span className='custom-page-css text-base font-regular'>phút</span>
                </div>
            </div>
            <div className="custom-page-css flex items-center justify-between">
                <span className='custom-page-css text-base font-medium'>Mẫu email thông báo</span>
                <Button onClick={() => navigate("/system-configuration/notification-email-template")} type="primary" icon={<MailOutlined />}>Thiết lập mẫu thông báo</Button>
            </div>
        </div>
    )
}

export default Share
